import { render, staticRenderFns } from "./LabEquilibrium.vue?vue&type=template&id=3f27c542&"
import script from "./LabEquilibrium.vue?vue&type=script&lang=ts&"
export * from "./LabEquilibrium.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports